import UserError from './UserError.js'

export class GetMessagingAdsListUserError extends UserError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new GetMessagingAdsListUserError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {message: this.#message}
  }
}
